import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
mixpanel.init("8f8dfbb30115e3b024e29b924e6805c0", {
  debug: process.env.NODE_ENV !== 'production', // Only enable debug in development
  track_pageview: true,
  persistence: "localStorage",
  // ignore_dnt: false, // Respect Do Not Track settings
  // api_host: "https://api-eu.mixpanel.com", // Use EU server for GDPR compliance if needed
  // batch_requests: true, // Enable batching for better performance
  // property_blacklist: ["$current_url", "$initial_referrer", "$referrer"], // Exclude sensitive data
});

// Set up user identification when they log in
// This will be called from your login component
export const identifyUser = (userId: string, userProps: any) => {
  mixpanel.identify(userId);
  mixpanel.people.set({
    ...userProps,
    'Last Login': new Date().toISOString(),
  });
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
